export default __webpack_public_path__ + "static/media/calatrava.b8675bad.jpg";